<template>
    <div class="report-wrap" @click="closeModal" v-if="show">
        <div class="report-dialog" @click.stop="">
            <div class="report-header">
                <div class="title">
                    举报
                </div>
                <div class="close" @click="closeModal"><img src="./images/close.png" alt="关闭"></div>
            </div>
            <div class="form">
                <tsa-form :rules="rulesform" :model="modelform" ref="reportForm">
                    <tsa-form-item label="举报链接" prop="link">
                        <tsa-input disabled v-model="modelform.link" placeholder="请输入举报链接" />
                    </tsa-form-item>
                    <tsa-form-item label="举报原因" prop="reason">
                        <tsa-radio-group v-model="modelform.reason">
                            <tsa-radio v-for="item in reasonList" :key="item.value" :label="item.title">{{item.title}}</tsa-radio>
                        </tsa-radio-group>
                    </tsa-form-item>
                    <tsa-form-item label="详细原因（选填）" prop="reasonDetail">
                        <tsa-input type="textarea" v-model="modelform.reasonDetail" maxlength="200" show-word-limit rows="4" cols="30" placeholder="提供更多信息" />
                    </tsa-form-item>
                    <tsa-form-item label="手机号" prop="phone">
                        <tsa-input v-model="modelform.phone" placeholder="请输入手机号码" />
                    </tsa-form-item>
                    <tsa-form-item label="邮箱" prop="email">
                        <tsa-input v-model="modelform.email" placeholder="请输入邮箱地址" />
                    </tsa-form-item>
                </tsa-form>
                <div class="btns">
                    <span class="primary" @click="submitForm('reportForm')">提交</span>
                    <!-- <span class="info" @click="resetForm('reportForm')">重置</span> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TsaForm from "@/components/TsaForm/Form";
import TsaFormItem from "@/components/TsaForm/FormItem";
import TsaInput from "@/components/TsaForm/Input";
import TsaRadioGroup from "@/components/TsaForm/Radio/radio-group";
import TsaRadio from "@/components/TsaForm/Radio/radio";
import { sendReport} from "@/api/tsaService.js";
export default {
    data () {
        var vphone = (rule, value, callback) => {
            if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error("输入的手机格式不正确"));
            }
            callback();
        };
        var vemail=(rule, value, callback) => {
            var reg = new RegExp(
                "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\\.){1,63}[a-z0-9]+$"
                );
            if (!reg.test(value)) {
                callback(new Error("输入的邮箱格式不正确"));
            }
            callback();
        };
        return {
            modelform:{
                link:this.reportLink,
                reasonDetail:'',
                reason:'',
                phone:'',
                email:'',
            },
            rulesform:{
                link:[
                    {required: true, message: "请输入举报链接",trigger: "blur"},
                ],
                reason: [
                    { required: true, message: '请选择举报原因', trigger: 'change' }
                ],
                phone:[
                    {required: true, message: "请输入联系人手机号",trigger: "blur"},
                    { validator: vphone, trigger: "blur" },
                ],
                email:[
                    {required: true, message: "请输入联系人邮箱",trigger: "blur"},
                    { validator: vemail, trigger: "blur" },
                ]
            },
            reasonList:[
                {
                    title:'涉嫌违法违规',
                    value:1
                },
                {
                    title:'色情低俗',
                    value:2
                },
                {
                    title:'恐怖恶心',
                    value:3
                },
                {
                    title:'未成年人不良内容',
                    value:4
                },
                {
                    title:'文字/图片侵权',
                    value:5
                },
                {
                    title:'违规营销信息',
                    value:6
                },
                {
                    title:'传播网络迷信信息',
                    value:7
                },
                {
                    title:'为线下违法活动引流',
                    value:8
                },
                {
                    title:'组织操纵刷分控评',
                    value:9
                },
                {
                    title:'炫富拜金、暴饮暴食、骄奢旅费等不良向导信息',
                    value:10
                },
                {
                    title:'其他',
                    value:11
                }
            ]
        }
    },
    props: {
        show: {
            type: Boolean,
            default: () => false,
        },
        reportLink:{
            type: String,
            default: () =>'',
        }
    },
    components: {TsaForm,TsaFormItem,TsaInput,TsaRadioGroup,TsaRadio},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        submitForm(formName){
            this.$refs[formName].validate(valid => {
                if(valid){
                    sendReport(this.modelform).then((res)=>{
                        console.log("提交成功")
                        this.resetForm('reportForm');
                        this.closeModal();
                        this.$emit("onToast", '提交成功');
                    })
                }else{
                    console.log("提交失败")
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        closeModal(){
            this.$emit('onClose');
        }
    },
}

</script>
<style scoped lang='less'>
.report-wrap{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99999;
    overflow: auto;
    background: rgba(0,0,0,.4);
    .report-dialog{
        width: 600PX;
        margin:40px auto 20px;
        box-sizing: border-box;
        background: #fff;
        border-radius: 6PX;
        .report-header{
            position: relative;
            .title{
                padding:50PX 0 20PX;
                text-align: center;
                font-size: 24PX;
                color: #000;
                font-weight: 500;
                font-family: 'PingFang SC-Medium' , 'PingFang SC';
            }
            .close{
                position: absolute;
                top: 14PX;
                right: 17PX;
                cursor: pointer;
            }
        }
        .form{
            padding:0 45PX 38PX;
            .btns{
                padding-top: 10PX;
                text-align: center;
                span{
                    margin:0 10PX;
                    display: inline-block;
                    user-select: none;
                    width: 140PX;
                    height: 38PX;
                    line-height: 38PX;
                    cursor: pointer;
                    border-radius: 3PX;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    padding-left: 7PX;
                    color: #FFF;
                    font-size: 16PX;
                    letter-spacing: 7PX;
                    text-align: center;
                }
                .primary{
                    background-color: #0047ff;
                    &:hover {
                        box-shadow: 2PX 3PX 8PX 0PX rgba(0,0,0,0.25), -2PX -3PX 8PX 0PX rgba(0,0,0,0.25);
                    }
                }
                .info{
                    background-color: #E1E0E0;
                    &:hover {
                        background-color: #C1C1C1;
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 750px) {
    .report-wrap{
        .report-dialog{
            width: 610px;
            margin:40px auto 20px;
            border-radius: 28px;
            .report-header{
                .title{
                    padding:30px 0 20px;
                    font-size: 48px;
                    font-weight: bold;
                }
                .close{
                    display: none;
                }
            }
            .form{
                padding:0 50px 96px;
                .btns{
                    padding-top: 20px;
                    text-align: center;
                    span{
                        margin:0 10px;
                        width: 206px;
                        height: 64px;
                        line-height: 64px;
                        border-radius: 6px;
                        padding-left: 0px;
                        font-size: 28px;
                        letter-spacing:normal;
                    }
                }
            }
        }
    }
}
</style>